module.exports = __webpack_public_path__ + "static/media/logo-tp.745965ee.svg";